export enum HorizontalAlignmentEnum {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}

export enum VerticalAlignmentEnum {
  Top = 'top',
  Center = 'center',
  Bottom = 'bottom',
}

export enum BackgroundStyleEnum {
  White = 'White',
  Black = 'Black',
  LightGray = 'Light Gray',
  TextureLight = 'Texture Light',
  TextureDark = 'Texture Dark',
  ButcherPaper = 'Butcher Paper',
  DarkGray = 'Dark Gray',
}
